// extracted by mini-css-extract-plugin
export default {"large":"ReplyIconButton_large__cqZGM","container":"ReplyIconButton_container__OZ5Pk"};